import { render } from "./AdminExtratosView.vue?vue&type=template&id=76da9e52&scoped=true"
import script from "./AdminExtratosView.vue?vue&type=script&lang=js"
export * from "./AdminExtratosView.vue?vue&type=script&lang=js"

import "./AdminExtratosView.vue?vue&type=style&index=0&id=76da9e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76da9e52"]])

export default __exports__